import React from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Landing      from './pages/Landing';
import AboutPage    from './pages/AboutPage';
import BlogPage     from './pages/BlogPage';
import BlogPostPage from './pages/BlogPostPage';
import './App.css';

export default function App() {
  return (
    <BrowserRouter>
      <Routes>
        <Route path="/"           element={<Landing />} />
        <Route path="/about"      element={<AboutPage />} />
        <Route path="/blog"       element={<BlogPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
      </Routes>
    </BrowserRouter>
  );
}
